import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  Input,
  ViewChild
} from '@angular/core';
import { find, get, size } from 'lodash';
import { NgModel } from '@angular/forms';
import { CommonRegEx } from '@nrwl/common-lib';
import { ActiveTestWizardService } from '../../services/active.test/active.test.wizard.service';

@Component({
  selector: 'proxy-settings',
  templateUrl: './proxy.settings.template.html',
  styleUrls: ['./proxy.settings.style.scss']
})
export class ProxySettingsComponent implements OnChanges, OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() parentOutput: any; // <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() defaultProxy: any; // <
  @Input() parent: string; //@
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdate: EventEmitter<any> = new EventEmitter();
  @Input() key: string; //@
  @ViewChild('addressInput') proxyAddressControl: NgModel;
  @ViewChild('portInput') portControl: NgModel;

  webProxyOption: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  port: any;
  protocol: string;
  // tslint:disable-next-line:max-line-length
  validAddressRegex: RegExp = CommonRegEx.DNS_NAME;
  defaultProxyURL: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  address: any;

  constructor(private readonly activeTestWizardService: ActiveTestWizardService) {}

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  initDefaults() {
    this.webProxyOption = this.parent === 'monitor' ? 'Default' : 'None';
    this.port = 80;
    this.protocol = 'http';
    this.defaultProxyURL = '';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  _rePopulateSelectionState() {
    // restore 'selection' if user clicked 'Back' to revisit the page
    this.protocol = 'http';

    if (this.parent === 'monitor') {
      const metaDataInfo = get(this.parentOutput, 'meta_data', []);
      const metaData = size(metaDataInfo) ? metaDataInfo : get(this.parentOutput, 'metaData', []);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const knownChoice: any = find(metaData, { key: this.key });
      if (knownChoice !== undefined) {
        const value = JSON.parse(knownChoice.value);

        if (value === this.activeTestWizardService.noProxy) {
          // here temporary because there are some old saved
          // monitors with this value
          this.webProxyOption = 'None';
        } else if (value.config.useDefault) {
          this.webProxyOption = 'Default';
        } else if (value.config.protocol) {
          this.webProxyOption = 'Custom';
          this.protocol = value.config.protocol;
          this.address = value.config.address;
          this.port = value.config.port;
        } else {
          this.webProxyOption = 'None';
        }
      }
    } else {
      if (this.parentOutput.webProxy !== undefined) {
        if (this.parentOutput.webProxy.port !== null) {
          this.webProxyOption = 'Custom';
          this.protocol = this.parentOutput.webProxy.protocol;
          this.address = this.parentOutput.webProxy.address;
          this.port = this.parentOutput.webProxy.port;
        }
      } else {
        this.webProxyOption = 'None';
      }
    }
  }

  ngOnInit() {
    this.initDefaults();
  }

  ngOnChanges() {
    setTimeout(() => {
      if (
        this.defaultProxy !== undefined &&
        this.defaultProxy !== null &&
        this.defaultProxy !== ''
      ) {
        this.defaultProxyURL = `${this.defaultProxy.protocol}://${this.defaultProxy.address}:${this.defaultProxy.port}`;
      }
      this._rePopulateSelectionState();
      this._onClick(this.webProxyOption);
    }, 0);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  _onClick(option): void {
    this.protocol = 'http';
    this.webProxyOption = option;
    setTimeout(() => {
      const value = this._makeOutput();
      if (this.parent === 'monitor') {
        this.onUpdate.emit({
          key: this.key,
          value: JSON.stringify(value),
          isValid: this._checkValidData(value)
        });
      } else {
        this.onUpdate.emit({
          key: this.key,
          value,
          isValid: this._checkValidData(value)
        });
      }
    }, 0);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  _makeOutput() {
    const proxyConfig = {
      config: {
        useDefault: true,
        protocol: null,
        address: null,
        port: null
      }
    };

    if (this.webProxyOption === 'None') {
      proxyConfig.config.useDefault = false;
    } else if (this.webProxyOption === 'Custom') {
      proxyConfig.config.useDefault = false;
      proxyConfig.config.protocol = this.protocol;
      proxyConfig.config.address = this.address;
      this.port = this._choosePort();
      proxyConfig.config.port = this.port;
    }

    return proxyConfig;
  }

  _choosePort(): void {
    if (this.protocol === 'http') {
      return !this.port || this.port === 443 ? 80 : this.port;
    } else {
      return !this.port || this.port === 80 ? 443 : this.port;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  _checkValidData(value): boolean {
    if (this.webProxyOption !== 'Custom') {
      return true;
    } else {
      if (value.config.protocol !== undefined && value.config.address !== undefined) {
        return this.portControl.control.valid && this.proxyAddressControl.control.valid;
      } else {
        return false;
      }
    }
  }
}
